'use strict'

import { request } from '~/utils/request'

export const actions = {
  /**
   * Get the url to redirect the user to initiate the HelloAsso authentication.
   * @param {Number} clubId the club identifier.
   * @param {Boolean} renew whether to renew the token or create a new connection.
   * @returns {Promise<{url}>}
   */
  async getHelloAssoAuthUrl(_, { clubId, renew } = {}) {
    const { data } = await request(this, 'club').post(
      '/oauth/helloasso',
      {},
      { club_id: clubId, renew }
    )
    return data
  },
}
